import gql from 'graphql-tag';

export const GET_VIDEO = gql`
  query getVideo(
    $personId: ID!, 
    $projectId: ID!, 
    $referenceId: ID!
  ) {
    Video(
      personId: $personId, 
      projectId: $projectId, 
      referenceId: $referenceId
    ){
      __typename
      id,
      title,
      subtitle,
      version,
      creationDate {formatted},
      creationDateIsApproximate,
      lastModifiedDate {formatted},
      type,
      proprietaryId,
      proprietaryIdNamespace,
      status,
      url,
      isrc,
      project {
        id,
        title,
        status,
        type,
        owners {
          id,
          fullName,
          __typename
        }
      }
      comments {
        id,
        text,
        creationDate {
          formatted
        }
        lastModifiedDate { formatted },
        author {
          id,
          accountId,
          fullName,
          imageDepictions {
            id,
            title,
            type,
            thumbnail { 
              id, 
              file { 
                uri 
                }
              }
            }
          __typename
        }
      }
      genres {
        id,
        name
      }
      contributions {
        id,
        contributor {
          id,
          fullName,
          __typename
        }
        role,
        isCredited,
        creditText,
        featured
      }
      rightShares {
        id,
        percent,
        territoryCode,
        owners {
          id,
          fullName,
          __typename
        }
        controllers {
          id,
          fullName,
          __typename
        }
        administrators {
          id,
          fullName,
          __typename
        }
        for {
          id,
          role
        }
      }
      file {
        id,
        proprietaryId,
        fileName,
        fileType,
        uri,
        size,
        bitDepth,
        bitRate,
        samplingRate,
        codecType
      }
      versions {
        id,
        title,
        file {
          id,
          proprietaryId,
          fileName,
          fileType,
          uri
        }
      }
      isVersionOf {
        id,
        title,
        file {
          id,
          proprietaryId,
          fileName,
          fileType,
          uri
        }
      }
      mood {
        id,
        name
      }
      equipment {
        id,
        name,
        type
      }
      referrer {
        __typename,
        ...on Project {
          id,
          title,
          status,
          type,
          owners {
            id,
            fullName,
            __typename
          }
        }
      }
      resourceOf {
        __typename,
        ...on Project {
          id,
          title,
          status,
          type,
          owners {
            id,
            fullName,
            __typename
          }
        }
      }
      isan,
      visan,
      catalogNumber,
      eidr,
      duration,
      numberOfAudioChannels,
      frameRate,
      height,
      width,
      previewStartPoint,
      previewDuration,
      previewType,
      work {
        id,
        title
      }
      release {
        id,
        title,
        type
      }
      thumbnail {
        id,
        file {
          id,
          uri
        }
      }
    }
  }
`;

export const CREATE_VIDEO = gql`
  mutation createVideo(
    $id: ID,
    $title: String,
    $subtitle: String,
    $version: String,
    $creationDate: _Neo4jDateTimeInput,
    $creationDateIsApproximate: Boolean,
    $lastModifiedDate: _Neo4jDateTimeInput,
    $type: String,
    $proprietaryId: String,
    $proprietaryIdNamespace: String,
    $status: String,
    $url: String,
    $isrc: String,
    $isan: String,
    $visan: String,
    $catalogNumber: String,
    $eidr: String,
    $duration: Int,
    $numberOfAudioChannels: Int,
    $frameRate: Float,
    $height: Int,
    $width: Int,
    $previewStartPoint: Int,
    $previewDuration: Int,
    $previewType: String
  ) {
    CreateVideo(
      id: $id,
      title: $title,
      subtitle: $subtitle,
      version: $version,
      creationDate: $creationDate,
      creationDateIsApproximate: $creationDateIsApproximate,
      lastModifiedDate: $lastModifiedDate,
      type: $type,
      proprietaryId: $proprietaryId,
      proprietaryIdNamespace: $proprietaryIdNamespace,
      status: $status,
      url: $url,
      isrc: $isrc,
      isan: $isan,
      visan: $visan,
      catalogNumber: $catalogNumber,
      eidr: $eidr,
      duration: $duration,
      numberOfAudioChannels: $numberOfAudioChannels,
      frameRate: $frameRate,
      height: $height,
      width: $width,
      previewStartPoint: $previewStartPoint,
      previewDuration: $previewDuration,
      previewType: $previewType
    ){
      id,
      title,
      subtitle,
      version,
      creationDate {formatted},
      creationDateIsApproximate,
      lastModifiedDate {formatted},
      type,
      proprietaryId,
      proprietaryIdNamespace,
      status,
      url,
      isrc,
      isan,
      visan,
      catalogNumber,
      eidr,
      duration,
      numberOfAudioChannels,
      frameRate,
      height,
      width,
      previewStartPoint,
      previewDuration,
      previewType
    }
  }
`;

export const CREATE_VIDEO_WITH_REFERRER = gql`
  mutation createVideoWithReferrer(
    $personId: ID!,
    $url: String!,
    $projectId: ID!,
  ) {
    CreateVideoWithReferrer(
      partyId: $personId,
      url: $url,
      projectId: $projectId,
    ){
      id,
      title,
      subtitle,
      version,
      creationDate {formatted},
      creationDateIsApproximate,
      lastModifiedDate {formatted},
      type,
      proprietaryId,
      proprietaryIdNamespace,
      status,
      url,
      isrc,
      isan,
      visan,
      catalogNumber,
      eidr,
      duration,
      numberOfAudioChannels,
      frameRate,
      height,
      width,
      previewStartPoint,
      previewDuration,
      previewType
    }
  }
`;

export const CREATE_VIDEO_PUBLIC_LIVESTREAM = gql`
  mutation createPublicLiveStream(
    $partyId: ID!,
    $profileId: ID!,
    $projectId: ID!,
    $url: String!
  ) {
    CreatePublicLiveStream(
      partyId: $partyId,
      profileId: $profileId,
      projectId: $projectId,
      url: $url
    ){
      id,
      title,
      subtitle,
      version,
      creationDate {formatted},
      creationDateIsApproximate,
      lastModifiedDate {formatted},
      type,
      proprietaryId,
      proprietaryIdNamespace,
      status,
      url,
      isrc,
      isan,
      visan,
      catalogNumber,
      eidr,
      duration,
      numberOfAudioChannels,
      frameRate,
      height,
      width,
      previewStartPoint,
      previewDuration,
      previewType
    }
  }
`;

export const CREATE_VIDEO_LIVESTREAM = gql`
  mutation createLiveStream(
    $partyId: ID!,
    $projectId: ID!,
    $url: String!
  ) {
    CreateLiveStream(
      partyId: $partyId,
      projectId: $projectId,
      url: $url
    ){
      id,
      title,
      subtitle,
      version,
      creationDate {formatted},
      creationDateIsApproximate,
      lastModifiedDate {formatted},
      type,
      proprietaryId,
      proprietaryIdNamespace,
      status,
      url,
      isrc,
      isan,
      visan,
      catalogNumber,
      eidr,
      duration,
      numberOfAudioChannels,
      frameRate,
      height,
      width,
      previewStartPoint,
      previewDuration,
      previewType
    }
  }
`;

export const UPDATE_VIDEO = gql`
  mutation updateVideo(
    $personId: ID!,
    $input: VideoInput
  ) {
    UpdateVideo(
      personId: $personId,
      input: $input
    ){
      id,
      title,
      subtitle,
      version,
      creationDate {formatted},
      creationDateIsApproximate,
      lastModifiedDate {formatted},
      type,
      proprietaryId,
      proprietaryIdNamespace,
      status,
      url,
      isrc,
      isan,
      visan,
      catalogNumber,
      eidr,
      duration,
      numberOfAudioChannels,
      frameRate,
      height,
      width,
      previewStartPoint,
      previewDuration,
      previewType
      __typename
    }
  }
`;

export const DELETE_VIDEO = gql`
  mutation deleteVideo (
    $personId: ID!,
    $referenceId: ID!
  ) {
    DeleteVideo(
      personId: $personId,
      referenceId: $referenceId
  ) {
    id
  }
}
`;

export const DELETE_VIDEO_LIVESTREAM = gql`
  mutation deleteLiveStream (
    $partyId: ID!,
    $projectId: ID!
    $videoId: ID!
  ) {
    DeleteLiveStream(
      partyId: $partyId,
      projectId: $projectId,
      videoId: $videoId
  ) {
    id
  }
}
`;

export const ADD_VIDEO_REFERRER = gql`
  mutation addVideoReferrer (
    $from: _ProjectInput!
    $to: _VideoInput!
  ) {
  AddVideoReferrer(
    from: $from
    to: $to
  ) {
    from { id }
    to { id }
    }
  }
`;


export const PUBLISH_VIDEO = gql`
  mutation publishVideo (
    $partyId: ID!, 
    $profileId: ID!, 
    $videoId: ID!
      ){
    PublishVideo (
      partyId: $partyId, 
      profileId: $profileId,
      videoId: $videoId
    ) {
      id
      }
    }
`;

export const UNPUBLISH_VIDEO = gql`
  mutation unpublishVideo (
    $partyId: ID!, 
    $profileId: ID!, 
    $videoId: ID!
      ){
    UnpublishVideo (
      partyId: $partyId, 
      profileId: $profileId,
      videoId: $videoId
    ) {
      id
      }
    }
`;

// AddVideoProject(
//   from: _ProjectInput!
//   to: _VideoInput!
// ): _AddVideoProjectPayload
// RemoveVideoProject(
//   from: _ProjectInput!
//   to: _VideoInput!
// ): _RemoveVideoProjectPayload
// AddVideoComments(
//   from: _CommentInput!
//   to: _VideoInput!
// ): _AddVideoCommentsPayload
// RemoveVideoComments(
//   from: _CommentInput!
//   to: _VideoInput!
// ): _RemoveVideoCommentsPayload
// AddVideoGenres(from: _GenreInput!, to: _VideoInput!): _AddVideoGenresPayload
// RemoveVideoGenres(
//   from: _GenreInput!
//   to: _VideoInput!
// ): _RemoveVideoGenresPayload
// AddVideoContributions(
//   from: _ContributionInput!
//   to: _VideoInput!
// ): _AddVideoContributionsPayload
// RemoveVideoContributions(
//   from: _ContributionInput!
//   to: _VideoInput!
// ): _RemoveVideoContributionsPayload
// AddVideoRightShares(
//   from: _ShareInput!
//   to: _VideoInput!
// ): _AddVideoRightSharesPayload
// RemoveVideoRightShares(
//   from: _ShareInput!
//   to: _VideoInput!
// ): _RemoveVideoRightSharesPayload
// AddVideoFile(from: _VideoInput!, to: _FileInput!): _AddVideoFilePayload
// RemoveVideoFile(from: _VideoInput!, to: _FileInput!): _RemoveVideoFilePayload
// AddVideoMood(from: _MoodInput!, to: _VideoInput!): _AddVideoMoodPayload
// RemoveVideoMood(from: _MoodInput!, to: _VideoInput!): _RemoveVideoMoodPayload
// AddVideoEquipment(
//   from: _VideoInput!
//   to: _EquipmentInput!
// ): _AddVideoEquipmentPayload
// RemoveVideoEquipment(
//   from: _VideoInput!
//   to: _EquipmentInput!
// ): _RemoveVideoEquipmentPayload
// AddVideoThumbnail(
//   from: _VideoInput!
//   to: _ImageInput!
// ): _AddVideoThumbnailPayload
// RemoveVideoThumbnail(
//   from: _VideoInput!
//   to: _ImageInput!
// ): _RemoveVideoThumbnailPayload
// AddVideoRelease(
//   from: _ReleaseInput!
//   to: _VideoInput!
// ): _AddVideoReleasePayload
// RemoveVideoRelease(
//   from: _ReleaseInput!
//   to: _VideoInput!
// ): _RemoveVideoReleasePayload
// AddVideoWork(from: _VideoInput!, to: _WorkInput!): _AddVideoWorkPayload
// RemoveVideoWork(from: _VideoInput!, to: _WorkInput!): _RemoveVideoWorkPayload
